type Candidate = {
  foundation: string,
  component: string,
  protocol: string,
  priority: number,
  ip: string,
  port: number,
  type: string,
  relatedAddress?: string,
  relatedPort?: number,
  tcpType?: string
};

export const parseCandidate = (line: string) => {
  let parts;

  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  const candidate: Candidate = {
    foundation: parts[0],
    component: parts[1],
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7],
  };

  for (let i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;

      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;

      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;

      default:
        // Unknown extensions are silently ignored.
        break;
    }
  }

  return candidate;
};
